import { RouterProvider } from 'react-router-dom';
import { Suspense } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { router } from './router';
import { queryClient } from '@/lib/queryClient';
import { useTenantMeta } from '@/hooks/useTenantMeta';
import { useUIStore } from '@/store/uiStore';

function TenantMetaLoader() {
  useTenantMeta();
  return null;
}

function App() {
  const language = useUIStore((s) => s.language);

  return (
    <QueryClientProvider client={queryClient}>
        <TenantMetaLoader />
        <Suspense
          fallback={(
            <div
              className="flex min-h-screen items-center justify-center bg-background"
              role="status"
              aria-live="polite"
              aria-label="Loading page"
            >
              <span className="h-9 w-9 animate-spin rounded-full border-4 border-primary/20 border-t-primary" />
            </div>
          )}
        >
          <RouterProvider router={router} />
        </Suspense>
        <ToastContainer
          position={language === 'ar' ? 'top-left' : 'top-right'}
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={language === 'ar'}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </QueryClientProvider>
  );
}

export default App;
